import BaseResource from './index'
import OptionValueResource from './optionValue'
import StateResource from './state'

export default class EmployeeResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/employees'

    static related() {
        return {
            main_state_id: StateResource,
            ethnicity_id: OptionValueResource,
        }
    }
}
